import { Directive, ElementRef, HostListener } from '@angular/core';

@Directive({
    selector: 'input[letterNumberDot]'
})
export class LettersNumberDotDirective {

    constructor(private _el: ElementRef) { }

    @HostListener('input', ['$event']) onInputChange(event) {
        const initalValue = this._el.nativeElement.value;
        this._el.nativeElement.value = initalValue.replace(/[^A-Za-z0-9Ññ\. ]*/g, '');
        if (initalValue !== this._el.nativeElement.value) {
            event.stopPropagation();
        }
    }
}
